<template>
  <h2 class="text-md md:text-md text-right font-medium text-gray-400">
    Current reporting cycle ending in {{ timeRemaining }} days
  </h2>
</template>

<script>
export default {
  name: 'ReportingCycle',

  props: {
    month: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      reportMonth: this.month,
    }
  },

  computed: {
    timeRemaining() {
      const currentDate = new Date()
      let currentYear
      if (currentDate.getMonth() > this.reportMonth) {
        currentYear = currentDate.getFullYear() + 1
      }
      else {
        currentYear = currentDate.getFullYear()
      }
      const daysInMonth = new Date(currentYear, this.reportMonth, 0).getDate()
      const endDate = new Date(
        `${this.reportMonth}/${daysInMonth}/${currentYear}`,
      )
      const diff = Math.floor(
        (endDate.getTime() - currentDate.getTime()) / (1000 * 3600 * 24),
      )

      return diff
    },
  },

  watch: {
    month(newMonth) {
      this.reportMonth = newMonth
    },
  },
}
</script>
